import React from "react";

type Props = {
  children: React.ReactNode;
  listName: string;
};

type State = {
  hasError: boolean;
};

class ItemListErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Recovery is owned by the watchdog in renderItemList (ItemList.tsx): it detects the
    // marked fallback rendered below, then remounts this boundary with a fresh `key` (which
    // resets hasError) and a bumped `generation` that busts the SWR cache so the re-render
    // fetches fresh data. A previous version retried here on a timer, but it re-rendered the
    // same cached bad list and only ever re-threw — fake recovery. We now just catch and log.
    console.error(`ItemList "${this.props.listName}" render error:`, error, info);
  }

  render() {
    if (this.state.hasError) {
      // Marked so the watchdog can tell a failed list apart from a healthy render: an error
      // fallback is a non-empty child that a naive childNodes length check reads as healthy.
      return <div data-list-failed="true" />;
    }
    return this.props.children;
  }
}

export default ItemListErrorBoundary;
